import * as rk from "../localization/resourceKeys";
import i18n from "../i18n";
import doNotSell from "../media/icons/DoNotSell.png";
import deleteInfo from "../media/icons/DeleteMyInfo.png";
import accessInfo from "../media/icons/AccessMyInfo.png";
import correctData from "../media/icons/CorrectData.png";

export const statesInfo = require("./statesInfo.json");
export let stateRights = {};

// These toggles are used to control the addition of states in the next releases.
// These toggles can be removed once all toggles are set to true (After January 2026).
const toggleOctober2025 = true;
const toggleJanuary2026 = true;

// Common rights.
const commonRights = {
  OptOut: {
    rightType: "OptOut",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.OPT_OUT),
    rightText: [
      i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY_VA1),
      i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY_VA2),
    ],
    rightImage: doNotSell,
    disabled: false,
    showInfo: false,
  },
  Delete: {
    rightType: "Delete",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO),
    rightText: [i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO_CARD_BODY1_VA)],
    rightImage: deleteInfo,
    disabled: false,
    showInfo: false,
  },
  Access: {
    rightType: "Access",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO),
    rightText: [i18n.t(rk.REQUEST_RIGHT.ACCESS_INFO_LINE1)],
    rightImage: accessInfo,
    disabled: false,
    showInfo: false,
  },
  Correct: {
    rightType: "Correct",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA),
    rightText: [i18n.t(rk.REQUEST_SELECTOR.DATA_CORRECTION_CARD_BODY)],
    rightImage: correctData,
    disbabled: false,
    showInfo: false,
  },
};

// California-like (CCPA) states
export const californiaLikeStates = ["CA"];

// CCPA (California Consumer Privacy Act) rights
const ccpaRights = [
  {
    rightType: "OptOut",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.OPT_OUT),
    rightText: [
      i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY_CA1),
      i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO_CARD_BODY_CA2),
    ],
    rightImage: doNotSell,
    disabled: false,
    showInfo: false,
  },
  {
    rightType: "Delete",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO),
    rightText: [i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO_CARD_BODY1_CA)],
    rightImage: deleteInfo,
    disabled: false,
    showInfo: false,
  },
  {
    rightType: "Access",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO),
    rightText: [i18n.t(rk.REQUEST_RIGHT.ACCESS_INFO_LINE1)],
    rightImage: accessInfo,
    disabled: false,
    showInfo: false,
  },

  {
    rightType: "Correct",
    rightTitle: i18n.t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA),
    rightText: [i18n.t(rk.REQUEST_SELECTOR.DATA_CORRECTION_CARD_BODY)],
    rightImage: correctData,
    disabled: false,
    showInfo: false,
  },
  // Unused CCPA rights
  // rightType: "DoNotUse", rightTitle: i18n.t(rk.REQUEST_SELECTOR.DO_NOT_USE_INFO),
  // rightType: "LimitData", rightTitle: i18n.t(rk.REQUEST_SELECTOR.LIMIT_DATA),
];

// Utah-like rights
const utahLikeRights = [
  commonRights["OptOut"],
  commonRights["Delete"],
  commonRights["Access"],
];

export const utahLikeStates = ["UT", "IA"];

// Virginia-like rights
const virginiaLikeRights = [
  commonRights["OptOut"],
  commonRights["Delete"],
  commonRights["Access"],
  commonRights["Correct"],
];

// States that are eligible for agent requests
export const elegibleAgentStates = [
  "CA", // California
  "CO", // Colorado
  "CT", // Connecticut
  "DE", // Delaware
  "IA", // Iowa
  "MT", // Montana
  "NH", // New Hampshire
  "NJ", // New Jersey
  "OR", // Oregon
  "UT", // Utah
  "VA", // Virginia
  "TX", // Texas
  "NE", // Nebraska
  "MN", // Minnesota
  "TN", // Tennessee
  ...(toggleOctober2025 ? ["MD"] : []), // Maryland will be added in October 2025
  ...(toggleJanuary2026 ? ["IN", "KY", "RI"] : []), // Indiana, Kentucky, and Rhode Island will be added in January 2026
];

export const virginiaLikeStates = [
  "CO",
  "CT",
  "DE",
  "VA",
  "NJ",
  "NH",
  "NE",
  "MT",
  "OR",
  "TX",
  "MN",
  "TN",
  // This is a temporary fix for the states that will be added during the next releases.
  // These toggles can be removed once all toggles are set to true (After January 2026).
  ...(toggleOctober2025 ? ["MD"] : []),
  ...(toggleJanuary2026 ? ["IN", "KY", "RI"] : []),
];

stateRights = {
  /* States that have CCPA-like rights */
  CA: ccpaRights,

  /* States that have Virginia-like rights */
  ...virginiaLikeStates.reduce((acc, state) => {
    acc[state] = virginiaLikeRights;
    return acc;
  }, {}),

  /* States that have Utah-like rights */
  ...utahLikeStates.reduce((acc, state) => {
    acc[state] = utahLikeRights;
    return acc;
  }, {}),

  /* Canada's QCP (Québec Privacy Portal) */
  QC: [
    {
      rightType: "Know",
      rightTitle: i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO),
      rightTitleKey: rk.REQUEST_SELECTOR.ACCESS_INFO_QC,
      rightText: [rk.REQUEST_SELECTOR.ACCESS_INFO_CARD_BODY_QC],
      rightImage: accessInfo,
    },
    {
      rightType: "Correct",
      rightTitle: i18n.t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA),
      rightTitleKey: rk.REQUEST_SELECTOR.CORRECT_MY_DATA_QC,
      rightText: [rk.REQUEST_SELECTOR.DATA_CORRECTION_CARD_BODY],
      rightImage: correctData,
    },
    {
      rightType: "Withdraw",
      rightTitle: i18n.t(rk.REQUEST_SELECTOR.WITHDRAW),
      rightTitleKey: rk.REQUEST_SELECTOR.WITHDRAW_QC,
      rightText: [
        rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_1,
        rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_2,
        rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_3,
        rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_4,
      ],
      rightImage: deleteInfo,
    },
  ],
};

// Is this used for PS validations?
export const texasLikeStates = ["TX", "NE"];

export const supportedStates = [
  // Unique values.
  ...new Set([
    "CA",
    ...californiaLikeStates,
    ...virginiaLikeStates,
    ...utahLikeStates,
    ...texasLikeStates,
  ]),
];

export const specialPolicyStates = ["CA", ...texasLikeStates];

const resetRights = (state) => {
  stateRights[state].forEach((item) => {
    if (item.rightTitle !== i18n.t(rk.REQUEST_SELECTOR.OPT_OUT)) {
      item.disabled = false;
      item.showInfo = false;
    }
  });
};

const handleAgentRights = (state, showInfo) => {
  stateRights[state].forEach((item) => {
    if (item.rightTitle !== i18n.t(rk.REQUEST_SELECTOR.OPT_OUT)) {
      item.disabled = true;
      item.showInfo = showInfo || false;
    }
  });
};

export const customerTypeRights = (
  state,
  customerType,
  onBehalfOf,
  brand = null
) => {
  // Reset props of the selected state in case its reselected for a different flow
  resetRights(state);

  const defaultRights = ["OptOut", "Delete", "Access", "Correct"];
  const isCA = californiaLikeStates.includes(state);
  const isTXLike = texasLikeStates.includes(state);
  const isUTLike = utahLikeStates.includes(state);
  const isQC = state === i18n.t(rk.STATE_QUEBEC);
  const isVWDriveEasy = brand === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);
  const isConsumer = customerType === i18n.t(rk.QUESTION_2_OPTION_1);
  const isPersonnel = customerType === i18n.t(rk.QUESTION_2_OPTION_2);
  const isAgent = onBehalfOf === i18n.t(rk.ON_BEHALF_OPTION_OTHER_CA);

  if (isCA) {
    if (isConsumer && isVWDriveEasy) {
      return ["Access", "Delete", "Correct"];
    }
    if (isConsumer) {
      return defaultRights;
    }
    if (isPersonnel) {
      return ["Access", "Delete", "Correct"];
    }
    if (isAgent) {
      // Handling disabling non-applicable rights for California for agent submitted requests only OptOut is applicable
      // Disable info tooltip for California only.
      handleAgentRights(state, true);
      return defaultRights;
    }
    // Rep of a business
    return ["Access", "Correct", "Delete"];
  }

  // Check if is Agent flow for all other states.
  if (isAgent) {
    // Show info for California only.
    handleAgentRights(state, false);
    if (isUTLike) {
      return ["OptOut", "Delete", "Access"];
    } else {
      // Virginia-like states and others
      return defaultRights;
    }
  }

  if (isTXLike) {
    return isVWDriveEasy ? ["Access", "Delete", "Correct"] : defaultRights;
  }

  if (isQC) {
    return ["Know", "Correct", "Withdraw"];
  }

  return defaultRights;
};
